import { UserShowcaseSearchDto } from '@/types';
import { getProfilePhoto } from '@/utils/profilePhoto';

const UserItem = ({
  user,
  index,
  onClick,
}: {
  user: UserShowcaseSearchDto;
  index: number;
  onClick: () => void;
}) => (
  <div key={user.id} className="border-b border-gray-d9 pb-7 px-3">
    <div onClick={onClick} className="flex items-center cursor-pointer">
      <span className="font-extrabold">{index + 1}</span>

      <img
        className="h-[52px] w-[52px] bg-gray-cc rounded-full ml-6"
        src={getProfilePhoto(user, 'original')}
        alt={user.userName}
      />

      <div className="flex-1 flex flex-col ml-3 truncate">
        <span className="text-gray-79 font-bold truncate">{user.userName}</span>

        <div className="flex items-center justify-between">
          <span className="text-sm text-gray-8a">{user.itemsCount} items</span>
          <span className="text-sm text-gray-8a ml-auto">{user.followersCount} followers</span>
        </div>
      </div>
    </div>
  </div>
);

export default UserItem;
